<template>
  <section class="c-section c-section--home">
    <div class="c-main d-flex justify-content-center align-items-center">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10">
            <transition name="fade" mode="out-in">
              <div v-if="step === 1" key="welcome">
                <div class="max-w">
                  <h1 class="c-title text-center white">
                    <div class="c-title__small">!Participa por</div>
                      1 Parlante
                  </h1>
                  <div class="c-welcome">
                    <div class="row">
                    <div class="col-12 col-lg-6">
                      <div class="c-welcome__text">
                        <h2 class="pri-color">
                          ¡Gracias
                        </h2>
                        <h4 class="pri-color mb-4">
                          por tomarte el tiempo
                          para responder esta encuesta!
                        </h4>
                        <p class="black mb-3">
                          Antes de iniciar la encuesta, por favor ten en cuenta que
                          se solicitarán tus datos personales completos
                          para poder ponernos en contacto contigo en caso salgas ganador
                          del sorteo por un <strong>Parlante bluetooth</strong>.
                        </p>
                        <p class="black">
                          <strong>Por lo tanto, solo aquellos que acepten proporcionar sus
                          datos personales pueden participar de la encuesta.</strong>
                        </p>
                        <div class="c-welcome__cont-btn mb-4">
                          <button @click="step = 2" class="c-button c-button--primary mt-2 mobile">
                          ¡EMPEZAR ENCUESTA!
                        </button>
                        </div>

                      </div>
                    </div>
                    <div class="col-12 col-lg-6">
                      <div class="c-welcome__figure h-100 position-relative">
                        <img class="mobile w-100" src="@/assets/img/bg-main-mobile.png">
                        <div class="c-welcome__btn  position-absolute h-100 w-100 d-flex
                        justify-content-end align-items-end">
                          <button @click="step = 2" class="c-button c-button--primary desktop mt-4">
                            ¡EMPEZAR ENCUESTA!
                          </button>
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                  <div class="c-terminos white mt-4 text-center">
                    <span @click="$bvModal.show('modalTerms')">Términos del Servicio</span> -
                    <span @click="$bvModal.show('modalPolitics')">Política de Privacidad</span>
                  </div>
                </div>
              </div>

              <div v-else-if="step === 2" key="user-personal">
                <div class="c-card c-card--names">
                  <div class="c-card__description bg-black">
                    <h2 class="white">DATOS PERSONALES</h2>
                    <p class="mb-0">¡Gracias por tomarte el tiempo de llenar esta encuesta!
                      Recuerda que solo respondiendo al 100% estarás participando
                      en el sorteo del Parlante.</p>
                  </div>
                  <div class="c-card__options">
                    <div
                      class="c-form-group mb-4"
                      :class="{ 'c-form-group--error': $v.participant.fullname.$error }"
                    >
                      <label class="c-form-group__label white">Nombres y Apellidos *</label>
                      <input
                        class="c-form-group__input"
                        type="text"
                        v-model.trim="$v.participant.fullname.$model"
                      />
                      <span class="c-form-group__error pl-0"
                        v-if="!$v.participant.fullname.required">
                        Nombres y apellidos son requeridos
                      </span>
                      <span class="c-form-group__error pl-0"
                        v-if="!$v.participant.fullname.letters">
                        Nombres y apellidos invalidos
                      </span>
                    </div>
                    <div
                      class="c-form-group mb-4"
                      :class="{ 'c-form-group--error': $v.participant.email.$error }"
                    >
                      <label class="c-form-group__label white">Correo Electrónico *</label>
                      <input
                        class="c-form-group__input"
                        type="email"
                        v-model.trim="$v.participant.email.$model" />
                      <span class="c-form-group__error" v-if="!$v.participant.email.required">
                        Email es requerido
                      </span>
                      <span class="c-form-group__error" v-if="!$v.participant.email.alpha">
                        Nombres invalidos
                      </span>
                    </div>
                    <div
                      class="c-form-group"
                      :class="{ 'c-form-group--error': $v.participant.terms.$error }"
                      >
                      <div class="c-card__options fs-18 p-0">
                        <div>
                          <label class="white">
                            <input
                              v-model="$v.participant.terms.$model"
                              type="checkbox"
                              value="Terminos"
                            />
                            Acepto los
                            <span class="c-pointer" @click="$bvModal.show('modalTerms')">
                              Términos y Condiciones
                            </span>
                          </label>
                        </div>
                      </div>
                      <span
                        class="c-form-group__error c-error p-0"
                        v-if="!$v.participant.terms.required"
                      >
                        Debe aceptar los Términos y Condiciones
                      </span>
                    </div>
                    <div
                      class="c-form-group mb-4"
                      :class="{ 'c-form-group--error': false }"
                    >
                      <div class="c-card__options fs-18 p-0">
                        <div>
                          <label class="white">
                            <input
                              v-model="participant.politics"
                              type="checkbox"
                              value="Politicas"
                            />
                            Acepto las
                            <span class="c-pointer" @click="$bvModal.show('modalPolitics')">
                              Políticas de Privacidad
                            </span>
                          </label>
                        </div>
                      </div>
                      <span class="c-form-group__error c-error p-0">
                        Debe aceptar las Políticas de Privacidad
                      </span>
                    </div>
                  </div>
                  <div class="c-card__footer d-flex align-items-center">
                    <div class="c-card__buttons d-flex">
                      <button @click="step = 1" class="c-button c-button--primary-flat mt-2">
                        Anterior
                      </button>
                      <button @click="nextStep(3)" class="c-button c-button--primary-flat mt-2">
                        Siguiente
                      </button>
                    </div>
                    <div class="c-card__tag">
                      <span class="white">*Obligatorio</span>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else-if="step === 3" key="user-age">
                <div class="c-card">
                  <div
                    class="c-form-group"
                    :class="{ 'c-form-group--error': $v.participant.age.$error }"
                  >
                    <div class="c-card__question">
                      Edad:
                    </div>
                    <div class="c-card__options fs-18">
                      <div>
                        <label class="white">
                          <input
                            type="radio"
                            v-model="$v.participant.age.$model"
                            value="Menor de 18 años"
                          />
                          Menor de 18 años
                        </label>
                      </div>
                      <div>
                        <label class="white">
                          <input
                            type="radio"
                            v-model="$v.participant.age.$model"
                            value="De 18 a 24 años"
                          />
                          De 18 a 24 años
                        </label>
                      </div>
                      <div>
                        <label class="white">
                          <input
                            type="radio"
                            v-model="$v.participant.age.$model"
                            value="De 25 a 30 años"
                          />
                          De 25 a 30 años
                        </label>
                      </div>
                      <div>
                        <label class="white">
                          <input
                            type="radio"
                            v-model="$v.participant.age.$model"
                            value="De 31 a 35 años"
                          />
                          De 31 a 35 años
                        </label>
                      </div>
                      <div>
                        <label class="white">
                          <input
                            type="radio"
                            v-model="$v.participant.age.$model"
                            value="De 36 a 40 años"
                          />
                          De 36 a 40 años
                        </label>
                      </div>
                      <div>
                        <label class="white">
                          <input
                            type="radio"
                            v-model="$v.participant.age.$model"
                            value="De 41 a más"/>
                          De 41 a más
                        </label>
                      </div>
                    </div>

                    <span class="c-form-group__error c-error" v-if="!$v.participant.age.required">
                      Edad es requerido
                    </span>
                  </div>
                  <div
                    class="c-form-group c-card__error"
                    :class="{ 'c-form-group--error': $v.participant.sex.$error }"
                  >
                    <div class="c-card__question pt-2">
                      Sexo:
                    </div>
                    <div class="c-card__options">
                      <div>
                        <label class="white">
                          <input type="radio" v-model="$v.participant.sex.$model" value="Femenino">
                          Femenino
                        </label>
                      </div>
                      <div>
                        <label class="white">
                          <input type="radio" v-model="$v.participant.sex.$model" value="Masculino">
                          Masculino
                        </label>
                      </div>
                    </div>

                    <span class="c-form-group__error
                      c-error"
                      v-if="!$v.participant.sex.required">
                      Sexo es requerido
                    </span>
                  </div>
                  <div class="c-card__footer d-flex align-items-center">
                    <div class="c-card__buttons d-flex">
                      <button @click="step = 2" class="c-button c-button--primary-flat mt-2">
                        Anterior
                      </button>
                      <button @click="nextStep(4)" class="c-button c-button--primary-flat mt-2">
                        Siguiente
                      </button>
                    </div>
                    <div class="c-card__tag">
                      <span class="white">*Obligatorio</span>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else-if="step === 4" key="user-location">
                <div class="c-card">
                  <div
                    class="c-form-group mb-2"
                    :class="{ 'c-form-group--error': $v.participant.department.$error }"
                  >
                    <div class="c-card__question">
                      ¿En qué departamento vive? *
                    </div>
                    <div class="c-card__options">
                      <select class="c-form-group__select"
                        v-model="$v.participant.department.$model"
                        @change="getProvincias"
                      >
                        <option disabled value="" selected>
                          Escoge tu departamento
                        </option>
                        <option
                          v-for="dep of departamentos"
                          :key="dep.id"
                          :value="dep.nombre_ubigeo"
                        >
                          {{ dep.nombre_ubigeo }}
                        </option>
                      </select>
                    </div>
                    <span
                      class="c-form-group__error c-error"
                      v-if="!$v.participant.department.required"
                    >
                      Elija una opcion
                    </span>
                  </div>

                  <div
                    class="c-form-group mb-2"
                    :class="{ 'c-form-group--error': $v.participant.province.$error }"
                  >
                    <div class="c-card__question pt-2">
                      ¿En qué provincia vive? *
                    </div>
                    <div class="c-card__options">
                      <select class="c-form-group__select"
                        v-model="$v.participant.province.$model"
                        @change="getDistritos"
                      >
                        <option disabled value="" selected>
                          {{
                            (loading.province)
                              ? 'Cargando...'
                              :'Escoge tu provincia'
                          }}
                        </option>
                        <option
                          v-for="prov of provincias"
                          :key="prov.id"
                          :value="prov.nombre_ubigeo"
                        >
                          {{ prov.nombre_ubigeo }}
                        </option>
                      </select>
                    </div>
                    <span
                      class="c-form-group__error c-error"
                      v-if="!$v.participant.province.required"
                    >
                      Elija una opcion
                    </span>
                  </div>

                  <div
                    class="c-form-group mb-4"
                    :class="{ 'c-form-group--error': $v.participant.district.$error }"
                  >
                    <div class="c-card__question pt-2">
                      ¿En qué distrito vive? *
                    </div>
                    <div class="c-card__options">
                      <select class="c-form-group__select"
                        v-model="$v.participant.district.$model">
                        <option disabled value="" selected>
                          {{
                            (loading.district)
                              ? 'Cargando...'
                              :'Escoge tu distrito'
                          }}
                        </option>
                        <option
                          v-for="dis of distritos"
                          :key="dis.id"
                          :value="dis.nombre_ubigeo"
                        >
                          {{ dis.nombre_ubigeo }}
                        </option>
                      </select>
                    </div>
                    <span
                      class="c-form-group__error c-error"
                      v-if="!$v.participant.district.required"
                    >
                      Elija una opcion
                    </span>
                  </div>

                  <div class="c-card__footer d-flex align-items-center">
                    <div class="c-card__buttons d-flex">
                      <button @click="step = 3" class="c-button c-button--primary-flat mt-2">
                        Anterior
                      </button>
                      <button @click="nextStep(5)" class="c-button c-button--primary-flat mt-2">
                        Siguiente
                      </button>
                    </div>
                    <div class="c-card__tag">
                      <span class="white">*Obligatorio</span>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else-if="step === 5" key="questions">
                <QuestionCard
                  v-model="questions[questionStep].answer"
                  :index="questionStep"
                  :body.sync="questions[questionStep]"
                  :type="questions[questionStep].type"
                  :valid="$v"
                  :step.sync="step"
                  :questionStep.sync="questionStep"
                  :lastQuestionStep.sync="lastQuestionStep" />
              </div>
              <div v-else-if="step === 6" key="thanks">
                <b-skeleton-wrapper :loading="loading.participant">
                  <template #loading>
                    <div class="c-card p-5">
                      <h3 class="text-center fs-21 w-bold white mb-3">Enviando...</h3>
                      <b-skeleton width="100%"></b-skeleton>
                    </div>
                  </template>

                  <div class="max-w">
                    <h1 class="c-title text-center white">
                      <div class="c-title__small">!Participa por</div>
                        1 Parlante
                    </h1>
                    <div class="c-welcome c-welcome--end">
                      <div class="row">
                      <div class="col-12 col-lg-6">
                        <div class="c-welcome__text">
                          <h2 class="pri-color">
                            ¡Gracias
                          </h2>
                          <p class="black">
                            Estaremos realizando el sorteo el día
                            <strong>13 de Abril del 2022</strong>
                            Mantente atento a tu correo registrado.
                          </p>
                          <h4 class="">
                            <strong>¡Mucha suerte!</strong>
                          </h4>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6">
                        <div class="c-welcome__figure h-100 position-relative">
                          <img class="mobile w-100" src="@/assets/img/bg-main-mobile.png">
                          <div class="c-welcome__btn  position-absolute h-100 w-100 d-flex
                          justify-content-end align-items-end">
                          </div>
                        </div>
                      </div>
                      </div>
                    </div>
                    <div class="c-terminos white mt-4 text-center">
                      <span @click="$bvModal.show('modalTerms')">Términos del Servicio</span> -
                      <span @click="$bvModal.show('modalPolitics')">Política de Privacidad</span>
                    </div>
                  </div>
                </b-skeleton-wrapper>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modalTerms"
      title="BootstrapVue" hide-footer hide-header hide-actions size="xl"
      centered
      scrollable>
      <div class="c-modal">
        <div class="text-end">
          <div class="text-end pe-3 pt-2">
            <span @click="$bvModal.hide('modalTerms')" class="c-modal__cross fs-30">
              <Icon icon="gridicons:cross-circle" />
            </span>
          </div>
        </div>
        <div class="p-4 pt-0">
          <h2 class="c-modal__title text-center w-bold">Términos y Condiciones</h2>
          <div v-html="(general.data.information) ? general.data.information.terms : ''"></div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modalPolitics"
      title="BootstrapVue" hide-footer hide-header hide-actions size="xl"
      centered
      scrollable>
      <div class="c-modal">
        <div class="text-end">
          <div class="text-end pe-3 pt-2">
            <span @click="$bvModal.hide('modalPolitics')" class="c-modal__cross fs-30">
              <Icon icon="gridicons:cross-circle" />
            </span>
          </div>
        </div>
        <div class="p-4 pt-0">
          <h2 class="c-modal__title text-center w-bold">Políticas de Privacidad</h2>
          <div v-html="(general.data.information) ? general.data.information.politics : ''"></div>
        </div>
      </div>
    </b-modal>

    <b-modal id="modalError" hide-footer hide-header hide-actions>
      <div class="c-modal">
        <div class="text-end">
          <div class="text-end pe-3 pt-2">
            <span @click="closeModalError()" class="c-modal__cross fs-30">
              <Icon icon="gridicons:cross-circle" />
            </span>
          </div>
        </div>
        <div class="p-4 text-center">
          <h2 class="c-modal__title">Error al enviar</h2>
          <p class="mb-0">
            ¡Ha ocurrido un error inesperado! 😥⚠️🚨,
            intentelo más tarde (revise sus datos)
          </p>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { Icon } from '@iconify/vue2';
import {
  required,
  requiredIf,
  helpers,
} from 'vuelidate/lib/validators';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      step: 1,

      questionStep: 0,
      lastQuestionStep: -1,

      departamentos: [],
      provincias: [],
      distritos: [],

      participant: {
        fullname: '',
        email: '',
        age: '',
        sex: '',
        department: '',
        province: '',
        district: '',
        terms: [],
        politics: [],
      },

      loading: {
        province: false,
        district: false,
        participant: false,
      },

      questions: [
        {
          id: 'Q1',
          type: 'radio',
          title: '¿Has escuchado publicidad de productos de Audio de alguna de las siguientes marcas? ',
          options: [
            'JBL',
            'Sony',
            'LG',
            'Samsung',
            'Huawei',
            'Apple',
            'No, no he escuchado publicidad de productos de Audio.',
          ],
          answer: '',
          jump: {
            options: ['No, no he escuchado publicidad de productos de Audio.'],
            to: 3,
          },
        },
        {
          id: 'Q2',
          type: 'radio',
          title: '¿Cuándo viste el último anuncio publicitario de productos de Audio?',
          options: [
            'Dentro de 2 semanas',
            'Hace 3 meses',
            'Hace 6 meses',
            'Hace más de 6 meses',
          ],
          answer: '',
        },
        {
          id: 'Q3',
          type: 'radio',
          title: '¿En qué medio escuchaste o viste publicidad de productos de Audio?',
          options: [
            'Facebook',
            'Instagram',
            'Youtube',
            'Google',
            'Spotify',
            'Tiendas',
          ],
          other: true,
          answer: '',
          answerOther: '',
        },
        {
          id: 'Q4',
          type: 'checkbox',
          title: '¿Qué producto/s de audio estas interesado en comprar?',
          options: [
            'Audífonos Inalámbricos',
            'Parlantes Bluetooth',
            'Equipos de Sonido',
            'No estoy interesado en comprar productos de audio ahora',
          ],
          answer: [],
        },
        {
          id: 'Q5',
          type: 'checkbox',
          title: '¿Qué característica valoras más en un producto de Audio? (Enumera del 1 al 6 siendo 6 la más importante)',
          options: [
            'Calidad de Sonido',
            'Diseño',
            'Compatibilidad Bluetooth',
            'Duración de Batería',
            'Precio',
            'Marca',
          ],
          order: true,
          answer: [],
        },
        {
          id: 'Q6',
          type: 'radio',
          title: '¿Qué Parlante portátil comprarías?',
          options: [
            'JBL',
            'Sony',
            'LG',
            'Huawei',
            'Logitech',
            'Bose',
          ],
          other: true,
          answer: '',
          answerOther: '',
        },
        {
          id: 'Q7',
          type: 'radio',
          title: '¿Qué Torre de Sonido comprarías?',
          options: [
            'Sony',
            'Samsung',
            'LG',
            'Panasonic',
            'Philips ',
          ],
          answer: '',
        },
        {
          id: 'Q8',
          type: 'radio',
          title: '¿Cuentas con audífonos inalámbricos?',
          options: [
            'Si, cuento con audífonos inalámbricos',
            'No, cuento con audífonos de cable',
            'No tengo audífonos',
          ],
          answer: '',
          jump: {
            options: ['No, cuento con audífonos de cable', 'No tengo audífonos'],
            to: 9,
          },
        },
        {
          id: 'Q9',
          type: 'radio',
          title: '¿De qué marca son tus audífonos inalámbricos?',
          options: [
            'Samsung',
            'Sony',
            'LG',
            'JBL',
            'Xiaomi',
            'Huawei',
          ],
          other: true,
          answer: '',
          answerOther: '',
        },
        {
          id: 'Q10',
          type: 'radio',
          title: '¿Has visto publicidad de audífonos inalámbricos, de qué marca?',
          options: [
            'Huawei',
            'Sony',
            'LG',
            'JBL',
            'Xiaomi',
            'Samsung',
            'Apple',
            'No he visto ni escuchado publicidad de audífonos inalámbricos.',
          ],
          answer: '',
          jump: {
            options: ['No he visto ni escuchado publicidad de audífonos inalámbricos.'],
            to: 11,
          },
        },
        {
          id: 'Q11',
          type: 'radio',
          title: '¿En qué medio escuchaste o viste publicidad de audífonos inalámbricos?',
          options: [
            'Facebook',
            'Instagram',
            'Youtube',
            'Google',
            'Spotify',
          ],
          other: true,
          answer: '',
          answerOther: '',
        },
        {
          id: 'Q12',
          type: 'radio',
          title: '¿Qué marca de audífonos inalámbricos comprarías?',
          options: [
            'JBL',
            'Sony',
            'Samsung',
            'LG',
            'Huawei',
            'Apple',
          ],
          answer: '',
        },
      ],
    };
  },
  computed: {
    ...mapState(['general']),
  },
  watch: {
    step() {
      if (this.step === 6) this.submit();
    },
  },
  validations: {
    participant: {
      fullname: {
        required,
        letters: helpers.regex('letters', /^[a-zA-Z ]+$/),
      },
      email: {
        required,
        alpha: helpers.regex('alpha', /.+@.+\..+/),
      },
      age: {
        required,
      },
      sex: {
        required,
      },
      department: {
        required,
      },
      province: {
        required,
      },
      district: {
        required,
      },
      terms: {
        required,
      },
    },

    questions: {
      required,
      $each: {
        answer: {
          required,
        },
        answerOther: {
          required: requiredIf(function validate() {
            return this.questions[this.questionStep].answer === 'other';
          }),
        },
      },
    },
  },
  components: {
    Icon,
    QuestionCard: () => import(/* webpackChunkName: "question-card" */'../components/QuestionCard.vue'),
  },
  mounted() {
    this.getDepartamentos();
  },
  methods: {
    nextStep(step) {
      this.$v.$touch();

      switch (step) {
        case 3:
          if (
            !this.$v.participant.fullname.$error
            && !this.$v.participant.email.$error
            && !this.$v.participant.terms.$error
          ) {
            this.$v.$reset();

            this.step = step;
          }
          break;

        case 4:
          if (
            !this.$v.participant.age.$error
            && !this.$v.participant.sex.$error
          ) {
            this.$v.$reset();

            this.step = step;
          }
          break;

        case 5:
          if (
            !this.$v.participant.department.$error
            && !this.$v.participant.province.$error
            && !this.$v.participant.district.$error
          ) {
            this.$v.$reset();

            this.step = step;
          }
          break;

        default:
          this.step = step;
          break;
      }
    },

    getDepartamentos() {
      fetch(`${process.env.VUE_APP_API}/geo`)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.departamentos = response.data;
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    getProvincias(option) {
      const department = this.departamentos[option.target.selectedIndex - 1].id_ubigeo;

      this.participant.province = '';
      this.participant.district = '';
      this.loading.province = true;

      this.provincias = [];
      this.distritos = [];

      fetch(`${process.env.VUE_APP_API}/geo?dep=${department}`)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.provincias = response.data;
          }

          this.loading.province = false;
        })
        .catch((err) => {
          this.loading.province = false;

          throw err;
        });
    },
    getDistritos(option) {
      const province = this.provincias[option.target.selectedIndex - 1].id_ubigeo;

      this.participant.district = '';
      this.loading.district = true;

      this.distritos = [];

      fetch(`${process.env.VUE_APP_API}/geo?prov=${province}`)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.distritos = response.data;
          }

          this.loading.district = false;
        })
        .catch((err) => {
          this.loading.district = false;

          throw err;
        });
    },

    submit() {
      this.loading.participant = true;

      const formData = new FormData();

      Object.keys(this.participant).forEach((key) => {
        formData.append(key, this.participant[key]);
      });

      formData.append('questions', JSON.stringify(this.questions));
      formData.append('politics', (this.participant.politics.length) ? 1 : 0);

      fetch(`${process.env.VUE_APP_API}/participants`, {
        method: 'POST',
        body: formData,
      })
        .then((res) => {
          if (res.status >= 200 && res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            window.setTimeout(() => {
              this.loading.participant = false;
            }, 1000);
          } else {
            this.$bvModal.show('modalError');
          }
        })
        .catch((err) => {
          this.$bvModal.show('modalError');

          throw err;
        });
    },
    closeModalError() {
      this.$bvModal.hide('modalError');

      this.step = 5;
      this.participant.loading = false;
    },
  },
};
</script>
